import { createSelector } from '@reduxjs/toolkit';

export const filtersSelector = createSelector(
    (state: ReturnType<any>) => state.filters,
    (state) => state,
);
